import RankBase from "../RankBase";
import Notice from "../Notice";

const COUPANG_RANK_TYPE = 'ST007'

const notices = [
    { text: '무료 회원은 3개까지 무료 등록이 가능합니다. (회원정보 사용 슬롯 참고)', style: { color: 'red' } },
    { text: '쿠팡 상품링크 주소는 키워드검색후 상단 링크 주소를넣어주세요.' },
    { text: '(예시) https://www.coupang.com/vp/products/7541003871?itemId=19824172006&vendorItemId=92141891658' },
    { text: '매일 순위 체크는 12시 부터 순차적으로 순위 업데이트 진행 합니다.' },
    { text: '쿠팡 특성상 순위가 다르게 보이기 때문에 최적화 참고용으로 보시기 바랍니다.' },
    { text: '순위 이력은 최근 3개월 내역까지 저장이되며, 3개월 경과건은 순차적으로 삭제 될 수 있습니다.' },
    { text: '순위는 300위까지 체크됩니다.' },
    { text: '순위 표시에 나오는 표시항목은 리뷰갯수, 별점 입니다.' },
    { text: '리 = 리뷰 갯수 / 별 = 별점' }
]

const CoupangNotice = () => (<Notice notices={notices} /> );
    
const CoupangRank = props => {
    return (
        <RankBase notice={CoupangNotice} type={COUPANG_RANK_TYPE} />
    )
}

export default CoupangRank;
